import { AlertNotification, Breed } from '@app/core/models';
import { Localization } from '@app/core/models/localization';
import { StepperItem } from '@app/core/services/tracking/types/interfaces';
import { Tool } from '@app/shared/utils';
import { RcToastProps } from '@rc-df/ds-web-components';

const rapidRecoStepperItems: StepperItem[] = [
  {
    label: 'step-catalog',
    isActive: true,
  },
  {
    label: 'step-patient-profile',
    mobileLabel: 'step-patient-profile-mobile',
  },
  {
    label: 'step-share-reco',
  },
];

const rapidRecoStepperItemsLegacy: StepperItem[] = [
  {
    label: 'step-catalog',
    isActive: true,
  },
  {
    label: 'step-share-reco',
  },
];
export type RcToastPropsExtended = RcToastProps & {
  id: string;
  dataQa?: string;
  duration?: number;
};
export interface CoreState {
  showLoader: boolean;
  showPopinLoader: boolean;
  loaderTransparent: boolean;
  showProgressBar: boolean;
  localization: Localization | undefined;
  tool: Tool | null;
  prevTool: Tool | null;
  tool_flow_id: string | null;
  breeds: Breed[];
  alerts: AlertNotification[];
  toasts: RcToastPropsExtended[];
  stepperItemsPerTool: { [key in Tool]?: StepperItem[] };
  stepperItemsPerToolLegacy: { [key in Tool]?: StepperItem[] };
}

export const initialCoreState: CoreState = {
  showLoader: false,
  showPopinLoader: false,
  loaderTransparent: false,
  showProgressBar: false,
  localization: undefined,
  tool: null,
  prevTool: null,
  tool_flow_id: null,
  breeds: [],
  alerts: [],
  toasts: [],
  stepperItemsPerTool: {
    [Tool.RapidReco]: rapidRecoStepperItems,
  },
  stepperItemsPerToolLegacy: {
    [Tool.RapidReco]: rapidRecoStepperItemsLegacy,
  },
};
